/**
 * Per-course Academy illustrations. The admin picks one from a dropdown on the
 * course (the `illustration` field uses `ACADEMY_ILLUSTRATION_OPTIONS`), and it
 * drives the course card, hero and lesson panels. Values are kebab-case slugs
 * matching the committed SVG names under `/assets-rebrand/illustrations/academy/`.
 *
 * Kept in a React-free module so the Payload collection config can import the
 * options without pulling in component code.
 *
 * `width`/`height` are the SVG viewBox dimensions, used by `next/image` to reserve
 * the correct aspect ratio (avoids layout shift). They are intrinsic sizing hints
 * only; the rendered size is controlled by `className` at each call site.
 */
export const ACADEMY_ILLUSTRATIONS: Record<
  string,
  { src: string; alt: string; width: number; height: number }
> = {
  'before-kubernetes': {
    src: '/assets-rebrand/illustrations/academy/before-kubernetes.svg',
    alt: 'Before Kubernetes illustration',
    width: 698,
    height: 806,
  },
  'kubernetes-setup': {
    src: '/assets-rebrand/illustrations/academy/kubernetes-setup.svg',
    alt: 'Kubernetes setup illustration',
    width: 523,
    height: 523,
  },
  'kubernetes-introduction': {
    src: '/assets-rebrand/illustrations/academy/kubernetes-introduction.svg',
    alt: 'Kubernetes introduction illustration',
    width: 361,
    height: 466,
  },
  'kubernetes-concepts': {
    src: '/assets-rebrand/illustrations/academy/kubernetes-concepts.svg',
    alt: 'Kubernetes concepts illustration',
    width: 640,
    height: 739,
  },
  'kubernetes-volumes': {
    src: '/assets-rebrand/illustrations/academy/kubernetes-volumes.svg',
    alt: 'Kubernetes volumes illustration',
    width: 732,
    height: 554,
  },
  'kubernetes-objects': {
    src: '/assets-rebrand/illustrations/academy/kubernetes-objects.svg',
    alt: 'Kubernetes objects illustration',
    width: 565,
    height: 529,
  },
  'kubernetes-config-security': {
    src: '/assets-rebrand/illustrations/academy/kubernetes-config-security.svg',
    alt: 'Kubernetes config and security illustration',
    width: 333,
    height: 433,
  },
  'kubernetes-networking': {
    src: '/assets-rebrand/illustrations/academy/kubernetes-networking.svg',
    alt: 'Kubernetes networking illustration',
    width: 511,
    height: 406,
  },
  'kubernetes-services': {
    src: '/assets-rebrand/illustrations/academy/kubernetes-services.svg',
    alt: 'Kubernetes services illustration',
    width: 485,
    height: 493,
  },
}

/** Select options for the `illustration` field, derived from the map so the two never drift. */
export const ACADEMY_ILLUSTRATION_OPTIONS: { label: string; value: string }[] = [
  { label: 'Before Kubernetes', value: 'before-kubernetes' },
  { label: 'Kubernetes Setup', value: 'kubernetes-setup' },
  { label: 'Kubernetes Introduction', value: 'kubernetes-introduction' },
  { label: 'Kubernetes Concepts', value: 'kubernetes-concepts' },
  { label: 'Kubernetes Volumes', value: 'kubernetes-volumes' },
  { label: 'Kubernetes Objects', value: 'kubernetes-objects' },
  { label: 'Kubernetes Config & Security', value: 'kubernetes-config-security' },
  { label: 'Kubernetes Networking', value: 'kubernetes-networking' },
  { label: 'Kubernetes Services', value: 'kubernetes-services' },
]
